import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3009/api/v1';

export type PublicAddressSite = {
  id: number;
  name: string;
  address: string;
  online: boolean;
};

export type PublicAddressHistoryRow = {
  id: number;
  siteId: number;
  siteName: string;
  operator: string;
  audioType: 'custom' | 'prerecorded';
  soundNumber: number | null;
  durationSeconds: number | null;
  status: 'queued' | 'failed';
  errorMessage: string | null;
  createdAt: string;
};

export async function getPublicAddressSites(token: string): Promise<PublicAddressSite[]> {
  const response = await axios.get(`${API_URL}/public-address/sites`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return Array.isArray(response.data?.data) ? response.data.data : [];
}

export async function getPublicAddressHistory(
  token: string,
  limit = 20,
): Promise<PublicAddressHistoryRow[]> {
  const response = await axios.get(`${API_URL}/public-address/history`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { limit },
  });
  return Array.isArray(response.data?.data) ? response.data.data : [];
}

type DispatchOptions = {
  token: string;
  siteId: number;
  audioType: 'custom' | 'prerecorded';
  durationSeconds: number;
  soundNumber?: number;
  audio?: Blob;
};

export async function dispatchPublicAddressAudio(options: DispatchOptions): Promise<void> {
  const body = options.audio ?? new Blob([], { type: 'application/octet-stream' });
  await axios.post(`${API_URL}/public-address/dispatches`, body, {
    headers: {
      Authorization: `Bearer ${options.token}`,
      'Content-Type': options.audio?.type || 'application/octet-stream',
      'X-Site-Id': String(options.siteId),
      'X-Audio-Type': options.audioType,
      'X-Duration-Seconds': String(options.durationSeconds),
      ...(options.soundNumber ? { 'X-Sound-Number': String(options.soundNumber) } : {}),
    },
  });
}
